<template>
    <teleport to="#modal">
        <AzioniSottoProgetto :id="id" v-model:visible="azioni_visible" v-model:tabindex="tabindex"
                             :sottoprogetto="sottoprogetto_model.titolo" :cliente_id="sottoprogetto_model.cliente_id"
                             :fee="dati.fee" :sections="ActiveTab.sezioni"
                             v-model:rebate="dati.rebate" :valute="dati.valute"
                             v-model:default_markup="dati.default_markup"
                             @update:valute="onUpdateValute" @update:fee="onUpdateFees"
                             @applica_mark_up_a_tutti="onApplicaMarkUpATutti"
                             v-model:nota="nota" v-model:tags="tags" v-model:infoPolicy="infoPolicy"
                             v-model:dataOfferta="dataOfferta"
                             v-model:terminiPagamento="terminiPagamento" v-model:sconto="sconto"
                             @saved="onChangeSottoProgetto"
                             @copiaStoricoVendite="onCambiaStoricoVendite"
                             @savePreference="syncUserPreference(tableHeader)"
                             @manualSave="versionamentoManuale" @savePolicy="savePolicy" @saveSconto="saveSconto"
                             @import="importSottoprogetto" v-model:waiting="waiting"></AzioniSottoProgetto>

        <ModalFeesDetail v-model:visible="show_fee_detail"></ModalFeesDetail>

        <ModalCaricaExcel @success="reloadExcelImport" :sottoprogetto_id="id" :backdrop="true"
                          v-model:visible="show_carica_excel"></ModalCaricaExcel>

        <Modal v-model:visible="modal_allegato_stato" backdrop>
            <template v-slot:header>
                <div>
                    <h2 class="text-lg font-bold mb-3">Richiesta apertura progetto</h2>
                </div>
            </template>
            <template v-slot:main>
                <p class="">Stai per richiedere l'apertura della commessa, allega un file di conferma del cliente
                    (email, contratto, etc).</p>
                <p class="mb-3">Con la richiesta di apertura stai confermando il preventivo <span class="font-bold">"{{
                        ActiveTab.titolo
                    }}"</span>, assicurati che sia quello corretto prima di
                    procedere.</p>

                <p class="mb-3">Oppure nel caso di "Accordo quadro" puoi procedere senza allegare alcun file</p>

                <div class="grid grid-cols-6 pt-3 border-t gap-3">
                    <div class="flex flex-col mb-3 col-span-3">
                        <Field field_name="Accordo quadro">
                            <Checkbox :checked="accordo_quadro" @change="accordo_quadro = !accordo_quadro"
                                      checkClass="w-4 h-4">
                                Accordo quadro
                            </Checkbox>
                        </Field>
                    </div>
                    <div class="flex flex-col mb-3 col-span-3">
                        <Field :labelVisible="false" :errors="modal_stato_errors['file_id']">
                            <FileUpload v-model:uploaded_files="uploaded_files" v-model:model_files="model_files"
                                        v-model:to_delete="to_delete"
                                        accept=".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx">
                                <template v-slot:default="{ props, methods }">
                                    <div class="flex flex-col grow">
                                        <NextButton variant="outline-secondary" @click="methods.open"
                                                    class="w-full h-10 px-4 grow">
                                            <i class="icon icon-graffetta"></i> Allega
                                        </NextButton>
                                        <div v-if="props.to_upload" class="grid grid-cols-1 gap-3">
                                            <a class="underline text-sm text-next-atp pt-3"
                                               v-for="(f, idx) in props.to_upload" :key="idx">
                                                <span>{{ f.name }}</span>
                                            </a>
                                        </div>
                                        <div v-if="uploaded_files" class="grid grid-cols-1 gap-3">
                                            <a class="underline text-sm text-next-atp pt-3  cursor-pointer"
                                               @click="downloadFile(f?.id)"
                                               v-for="(f, idx) in uploaded_files" :key="idx">
                                                <span>{{ f.name }}</span>

                                            </a>
                                        </div>
                                        <small v-for="(e, i) in modalFileError(props.errors)" :key="i"
                                               class="text-next-orange">{{ e }}</small>
                                    </div>
                                </template>
                            </FileUpload>
                        </Field>
                    </div>

                    <div class="flex flex-col lg:col-span-6">
                        <Field field_name="Descrizione" v-model="modal_stato.descrizione"
                               :errors="modal_stato_errors['descrizione']" placeholder="Descrizione">
                        </Field>
                    </div>
                    <div class="flex flex-col lg:col-span-2">
                        <Field field_name="Paese" :required="false"
                               :errors="modal_stato_errors['paese_id']" placeholder="Paese">
                            <VueMultiselect v-model="paeseAutocomplete.selection" :options="paeseAutocomplete.options"
                                            @search-change="paeseAutocomplete.search" :close-on-select="true"
                                            :clear-on-select="true" placeholder="Paese" deselectLabel="Deseleziona"
                                            selectedLabel="Selezionato" selectLabel="Seleziona"
                                            class="next-vue-multiselect-single"
                                            track-by="id" label="nome">
                                <template v-slot:noResult>Nessun elemento trovato.</template>
                            </VueMultiselect>
                        </Field>
                    </div>
                    <div class="flex flex-col lg:col-span-2">
                        <Field field_name="Numero Pax" :required="false" :errors="modal_stato_errors['numero_pax']"
                               v-model="modal_stato.numero_pax">
                        </Field>
                    </div>
                    <div class="flex flex-col lg:col-span-2">
                        <Field field_name="Città" :required="false" v-model="modal_stato.citta" type="text"
                               :errors="modal_stato_errors['citta']" placeholder="Città">
                        </Field>
                    </div>
                </div>

            </template>
            <template v-slot:footer>
                <div class="flex justify-end pt-3">
                    <NextButton variant="outline-secondary"
                                @click="this.uploaded_files.splice(0); modal_allegato_stato = false"
                                class="col-start-3 py-2 px-4">
                        Chiudi
                    </NextButton>

                    <NextButton variant="primary" @click="performCambioStatoWithFile" :disabled="loading_cambio_stato"
                                class="ml-4 py-2 px-4 flex items-center justify-center">
                        <Spinner v-show="loading_cambio_stato" class="w-4 h-4 mr-4"></Spinner>
                        Richiedi Apertura
                    </NextButton>
                </div>
            </template>
        </Modal>
    </teleport>
    <!--    modal per i context menu-->
    <div id="cmModal"></div>
    <!--    modal per le form select-->
    <div id="selectModal"></div>

    <div class="m-auto px-5 pb-32">
        <div class="m-auto">
            <div v-show="!StessaValutaVendita" class="pt-3 sticky top-0.5 z-10">
                <Alert class="bg-next-orange">Ci sono diverse valute di vendita nel budget</Alert>
            </div>
            <div class="py-5 flex justify-between items-center">
                <Breadcrumbs :paths="getBreadcrumbsPath"></Breadcrumbs>
                <div class="flex gap-3">
                    <div class="flex items-center">
                        <span class="whitespace-nowrap"
                              v-show="sottoprogetto_model.accordo_quadro">Accordo quadro</span>
                        <span class="whitespace-nowrap"
                              v-show="sottoprogetto_model.accordo_quadro && allegato_sottoprogetto"> / </span>
                        <a v-if="allegato_sottoprogetto"
                           class="underline text-sm text-next-atp whitespace-nowrap  cursor-pointer"
                           @click="downloadFile(allegato_sottoprogetto?.id)">
                            <span>{{ allegato_sottoprogetto?.name }}</span>
                        </a>
                    </div>
                    <SelectStato :sottoprogetto-id="id" @select="changeSottoprogettoStato"
                                 :modelValue="sottoprogetto_model.stato"></SelectStato>
                    <div class="bg-next-gray-md-dark text-sm py-1 px-2 flex items-center whitespace-nowrap">
                        Versione {{ sottoprogetto_model.last_major }}.{{ sottoprogetto_model.last_minor }} del
                        {{ $filters.toDate(sottoprogetto_model.updated_at) }} alle
                        {{ $filters.toTime(sottoprogetto_model.updated_at) }}
                    </div>
                </div>
            </div>
            <div class="flex justify-between items-end">

                <div class="text-3xl font-bold">{{ sottoprogetto_model.titolo }}</div>
                <div class="pl-4">
                    <div class="flex" v-show="salvataggio_pendente">
                        <svg role="status"
                             class="w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-next-orange"
                             viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"/>
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"/>
                        </svg>
                        <span>Salvataggio in corso...</span>
                    </div>
                    <span v-show="errore_salvataggio" class="text-next-orange">Errore durante il salvataggio: {{
                            errore_salvataggio
                        }}</span>
                </div>

                <div class="text-sm">ID progetto: {{ progetto_model?.id_gamma }} / Codice commessa:
                    {{ sottoprogetto_model?.cod_nodo }}
                </div>
            </div>
            <div class="mb-5">
                <small>da
                    <span class="font-bold"> {{
                            sottoprogetto_model.data_inizio ? $filters.toDate(sottoprogetto_model.data_inizio) : '-'
                        }}</span> a
                    <span class="font-bold">{{
                            sottoprogetto_model.data_fine ? $filters.toDate(sottoprogetto_model.data_fine) : '-'
                        }}</span>
                </small>
            </div>
            <SottoProgettoHead class="mb-5" @clickFee="show_fee_detail = true"
                               :budget="sottoprogetto_model.budget ? `${$filters.toEuroCurrency(Number(sottoprogetto_model.budget))}` : '-'"
                               :budgetProgetto="ActiveTab && TotaleBudgetProgettoConFee(ActiveTab.sezioni) ? `${$filters.toEuroCurrency(TotaleBudgetProgettoConFee(ActiveTab.sezioni))} (${$filters.toEuroCurrency(TotaleBudgetProgetto(ActiveTab.sezioni))})` : '-'"
                               :totaleRicavi="ActiveTab && TotaleRicaviProgetto(ActiveTab.sezioni) ? `${$filters.toEuroCurrency(TotaleRicaviProgettoConFee(ActiveTab.sezioni))} (${$filters.toEuroCurrency(TotaleRicaviProgetto(ActiveTab.sezioni))})` : '-'"
                               :commissioni="ActiveTab && TotaleCommissioniProgetto(ActiveTab.sezioni) ? $filters.toEuroCurrency(TotaleCommissioniProgetto(ActiveTab.sezioni)) : '-'"
                               :totaleCosti="ActiveTab && TotaleCostiEuroProgetto(ActiveTab.sezioni) ? $filters.toEuroCurrency(TotaleCostiEuroProgetto(ActiveTab.sezioni)) : '-'"
                               :utile="ActiveTab && TotaleUtiliProgetto(ActiveTab.sezioni) ? `${$filters.toEuroCurrency(TotaleUtiliProgettoConFee(ActiveTab.sezioni))} (${$filters.toEuroCurrency(TotaleUtiliProgetto(ActiveTab.sezioni))})` : '-'"
                               :margine="ActiveTab && TotaleMolProgetto(ActiveTab.sezioni) ? `${TotaleMolProgettoConFee(ActiveTab.sezioni).toLocaleValueString(2, 2)} % (${TotaleMolProgetto(ActiveTab.sezioni).toLocaleValueString(2, 2)} %)` : '-'"
                               :secondoMargine="ActiveTab && `${$filters.toEuroCurrency(TotaleUtiliProgettoConFee(ActiveTab.sezioni) - TotaleCostoRisorseProgetto(ActiveTab.sezioni))}`"
                               :totaleRisorse="ActiveTab && TotaleCostoRisorseProgetto(ActiveTab.sezioni) ? `${$filters.toEuroCurrency(TotaleCostoRisorseProgetto(ActiveTab.sezioni))}` : '-'"
                               :fee="ActiveTab && TotaleFeesSezioni(ActiveTab.sezioni) ? TotaleFeesSezioni(ActiveTab.sezioni).toLocaleValueString(2, 2) : '-'">
            </SottoProgettoHead>

            <div class="flex items-center justify-between">
                <ToolbarSottoProgetto :id="id" v-model:visible="azioni_visible"
                                      @toggleExpand="preventSaveOnToggleExpand" @update:tabindex="openToolbar">
                </ToolbarSottoProgetto>

                <NextButton variant="primary" @click="show_carica_excel = true"
                            class="p-1 flex items-center justify-center">
                    Carica Excel
                </NextButton>
            </div>

            <Tabs class="py-5" @addtab="addTab" @removetab="removeTab" @duplicatab="duplicaTab" :tabs="dati.tabs"
                  :disabled="(sottoprogetto_model?.stato?.PD1E_CODICE !== StatiSottoprogetto.OFFERTA && sottoprogetto_model?.stato?.PD1E_CODICE !== StatiSottoprogetto.OFFERTA_INVIATA)"
                  v-model="dati.active_tab" :allowDelete="dati.tabs.length > 1" @editingChange="onTabEditing"></Tabs>

            <template v-if="ActiveTab">
                <div class=" overflow-x-scroll">
                    <SezioneSottoProgetti v-model:titolo="s.titolo" v-for="(s, i) in ActiveTab.sezioni"
                                          :key="s.titolo + i" :deletable="ActiveTab.sezioni.length > 1" :order="i + 1"
                                          :last="i === ActiveTab.sezioni.length - 1" :first="i === 0"
                                          :expanded="s.expanded"
                                          @update:expanded="preventSaveOnToggleExpand(s)"
                                          @clickAddRow="addRowSezione(s)"
                                          @orderUp="handleOrderUp(ActiveTab.sezioni, i)"
                                          @orderDown="handleOrderDown(ActiveTab.sezioni, i)"
                                          @cancella="cancellaSezione(i)"
                                          @clickAggiungiSezione="aggiungiSezione(i)"
                                          @clickDuplicaSezione="duplicaSezione(i)"
                                          :totaleCosti="TotaleCostiEuroSezione(s) ? `${$filters.toEuroCurrency(TotaleCostiEuroSezione(s))}` : '-'"
                                          :budgetProgetto="TotaleBudgetProgettoSezione(s) ? `${$filters.toEuroCurrency(TotaleBudgetProgettoSezione(s))}` : '-'"
                                          :fee="TotaleFeesSezione(s) ? $filters.toEuroCurrency(TotaleFeesSezione(s)) : '-'"
                                          :primoMarigne="TotaleUtileEuroSezione(s) ? $filters.toEuroCurrency(TotaleUtileEuroSezione(s)) : '-'"
                                          :primoMarignePerc="TotaleMolSezione(s) ? `${TotaleMolSezione(s).toLocaleValueString(2, 2)} %` : '-'">
                        <NextSottoProgettoTable class="w-full border-separate" actionClass="hidden"
                                                nuvola_td_class="border-next-nuvola"
                                                alternativa_td_class="border-next-alternativa"
                                                opzionale_td_class="border-next-opzionale" :cols="tableHeader"
                                                @update:cols="syncUserPreference" :rows="s.ordered_records"
                                                @update:rows="onUpdateRows(s, $event)" @order-update="performOrder">
                            <template v-for="(rc, x) in rowCellIterator(s.ordered_records, sottoProgettiCols)" :key="x"
                                      v-slot:[`td_${rc}`]="{ row, cell }">
                                <DynamicCell :is_component="getComponent(row, cell)"
                                             @input="setValue(row, cell, $event.target.value)"
                                             :value="getValue(row, cell)"
                                             v-bind="getProps(row, cell)" class="h-6"></DynamicCell>
                            </template>

                            <template v-for="(c, j) in s.ordered_records" :key="j"
                                      v-slot:[`td_${j}_preactions`]="context">
                                <div class="flex items-center">
                                    <OffertaContextMenu
                                        menuClass="shadow absolute flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white"
                                        :context="c" :id="`i${i}_j${j}_${context.row.length}`" teleport_to="#cmModal"
                                        :cmOpener="cmOpener" @addNuvola="addNuvola(c)"
                                        @toggleDescrizione="toggleDescrizione(c)" @toggleOpzionale="toggleOpzionale(c)"
                                        @addAlternativa="addAlternativa(c)" @cancella="cancellaRecord(s, c)"
                                        @eliminaSottoriga="eliminaSottoriga(s, c)" @promuovi="promuoviSottoriga(s, c)"
                                        @duplicaRecord="duplicaRecord(s, c)"
                                        @duplicaSottoRecord="duplicaSottoriga(s, c)">
                                    </OffertaContextMenu>
                                    <Checkbox :disabled="!c._nuvola" checkClass="ml-3 block h-4 w-4"
                                              :checked="getValue(c, { prop: 'show_in_export' })"
                                              @change="setValue(c, { prop: 'show_in_export' }, !getValue(c, { prop: 'show_in_export' }))">
                                    </Checkbox>
                                </div>
                            </template>

                            <template v-for="(c, j) in s.ordered_records" :key="j"
                                      v-slot:[`td_${j}_ne_descrizione_servizio`]="{ row, cell }">
                                <DynamicCell :modelValue="getValue(row, cell)" :is_component="getComponent(row, cell)"
                                             v-bind="getProps(row, cell)" @confirm="setValue(row, cell, $event)"
                                             class="next-vue-multiselect-single overflow-ellipsis" titolo="Descrizione">
                                    <template v-slot:cell="option">
                                        {{ getValue(row, cell) }}
                                    </template>
                                    <template v-slot:main="option">
                                        <textarea class="border mb-3 border-next-dark-gray" rows=6
                                                  :value="getValue(row, cell)"
                                                  @input="option.setInternalValue($event.target.value)">
                                        </textarea>
                                    </template>
                                </DynamicCell>
                            </template>


                            <template v-for="(c, j) in s.ordered_records" :key="j"
                                      v-slot:[`td_${j}_ne_fornitore`]="{ row, cell }">
                                <DynamicCell :modelValue="getValue(row, cell)" :is_component="getComponent(row, cell)"
                                             v-bind="getProps(row, cell)" @confirm="setValue(row, cell, $event)"
                                             class="next-vue-multiselect-single overflow-ellipsis"
                                             :autocomplete="fornitoreAutocomplete" track-by="id" label="denominazione"
                                             placeholder="Fornitore" titolo="Fornitore">
                                    <template v-slot:main="option">
                                        <VueMultiselect :options="fornitoreAutocomplete.options"
                                                        v-model="fornitoreAutocomplete.selection"
                                                        :loading="fornitoreAutocomplete.isLoading"
                                                        @update:modelValue="option.setInternalValue($event)"
                                                        @search-change="fornitoreAutocomplete.search"
                                                        class="next-vue-multiselect-single overflow-ellipsis mb-3"
                                                        :close-on-select="true" :clear-on-select="false"
                                                        deselectLabel="Deseleziona"
                                                        selectedLabel="Selezionato" selectLabel="Seleziona"
                                                        track-by="id"
                                                        label="denominazione" placeholder="Fornitore"
                                                        titolo="Fornitore">
                                            <template v-slot:noResult>Nessun elemento trovato.</template>
                                            <template v-slot:singleLabel="{ option }">
                                                {{ `${option.denominazione} - ${option.ragione_sociale}` }}
                                            </template>
                                            <template v-slot:option="{ option }">{{
                                                    `${option.denominazione} - ${option.ragione_sociale}`
                                                }}
                                            </template>
                                        </VueMultiselect>
                                    </template>
                                </DynamicCell>
                            </template>

                            <template v-for="(c, j) in s.ordered_records" :key="j"
                                      v-slot:[`td_${j}_ne_stato`]="{ row, cell }">
                                <DynamicCell :modelValue="getValue(row, cell)" :is_component="getComponent(row, cell)"
                                             v-bind="getProps(row, cell)" titolo="Stato">
                                    <template v-slot:cell="{ value }">
                                        <template v-if="value">
                                            <div class="h-full w-full font-bold" :class="getStatoOffertaColor(row)">
                                                {{ value?.descrizione }}
                                            </div>
                                        </template>
                                    </template>
                                    <template #main>
                                        <VueMultiselect :modelValue="getValue(row, cell)"
                                                        @update:modelValue="setValue(row, cell, $event)"
                                                        :options="StatiOfferta"
                                                        :close-on-select="true" :clear-on-select="false"
                                                        placeholder="Stato"
                                                        class="mb-3 next-vue-multiselect-single"
                                                        deselectLabel="Deseleziona"
                                                        selectedLabel="Selezionato" selectLabel="Seleziona"
                                                        track-by="id"
                                                        label="descrizione">
                                        </VueMultiselect>
                                    </template>
                                </DynamicCell>
                            </template>

                            <template v-for="(c, j) in s.ordered_records" :key="j"
                                      v-slot:[`td_${j}_ne_tipologia`]="{ row, cell }">
                                <DynamicCell :modelValue="getValue(row, cell)" :is_component="getComponent(row, cell)"
                                             v-bind="getProps(row, cell)" titolo="Tipologia">
                                    <template v-slot:cell="{ value }">
                                        <template v-if="value">
                                            <div class="h-full w-full">
                                                {{ value?.descrizione }}
                                            </div>
                                        </template>
                                    </template>
                                    <template #main>
                                        <VueMultiselect :modelValue="getValue(row, cell)"
                                                        @update:modelValue="setValue(row, cell, $event)"
                                                        :options="Tipologia"
                                                        :close-on-select="true" :clear-on-select="false"
                                                        placeholder="Tipologia"
                                                        class="mb-3 next-vue-multiselect-single"
                                                        deselectLabel="Deseleziona"
                                                        selectedLabel="Selezionato" selectLabel="Seleziona"
                                                        track-by="id"
                                                        label="descrizione">
                                        </VueMultiselect>
                                    </template>
                                </DynamicCell>
                            </template>

                            <template v-for="(c, j) in s.ordered_records" :key="j"
                                      v-slot:[`td_${j}_ne_voce_spesa`]="{ row, cell }">
                                <DynamicCell :modelValue="getValue(row, cell)" :is_component="getComponent(row, cell)"
                                             v-bind="getProps(row, cell)" @confirm="setValue(row, cell, $event)"
                                             :autocomplete="vocespesaAutocomplete" class="next-vue-multiselect-single"
                                             placeholder="Voce di spesa" titolo="Voce di spesa" track-by="id"
                                             label="descrizione">
                                </DynamicCell>
                            </template>

                            <template v-for="(c, j) in s.ordered_records" :key="j"
                                      v-slot:[`td_${j}_ac_valuta`]="{ row, cell }">
                                <DynamicCell :modelValue="getValue(row, cell)" :is_component="getComponent(row, cell)"
                                             v-bind="getProps(row, cell)" @confirm="setValue(row, cell, $event)"
                                             :autocomplete="customValutaAutocomplete" titolo="Valuta di acquisto">
                                    <template v-slot:cell="{ value }">
                                        <template v-if="value">
                                            <span>{{
                                                    `${value.descrizione} - 1 ${value.valuta?.CG08_SIGLA} =
                                                ${value.valore} €`
                                                }}</span>
                                        </template>
                                    </template>
                                    <template v-slot:main="option">
                                        <VueMultiselect :options="customValutaAutocomplete.options"
                                                        v-model="customValutaAutocomplete.selection"
                                                        :loading="customValutaAutocomplete.isLoading"
                                                        @update:modelValue="option.setInternalValue($event)"
                                                        @search-change="customValutaAutocomplete.search"
                                                        class="next-vue-multiselect-single overflow-ellipsis mb-3"
                                                        :close-on-select="true" :clear-on-select="false"
                                                        deselectLabel="Deseleziona"
                                                        selectedLabel="Selezionato" selectLabel="Seleziona"
                                                        track-by="id"
                                                        placeholder="Valuta di acquisto">
                                            <template v-slot:noResult>Nessun elemento trovato.</template>
                                            <template v-slot:singleLabel="{ option }">
                                                {{
                                                    `${option.descrizione} - 1 ${option.valuta?.CG08_SIGLA} =
                                                ${option.valore} €`
                                                }}
                                            </template>
                                            <template v-slot:option="{ option }">
                                                {{
                                                    `${option.descrizione} - 1 ${option.valuta?.CG08_SIGLA} =
                                                ${option.valore} €`
                                                }}
                                            </template>
                                        </VueMultiselect>
                                    </template>
                                </DynamicCell>
                            </template>

                            <template v-for="(c, j) in s.ordered_records" :key="j"
                                      v-slot:[`td_${j}_ac_aliquota`]="{ row, cell }">
                                <DynamicCell :modelValue="getValue(row, cell)" :is_component="getComponent(row, cell)"
                                             v-bind="getProps(row, cell)" @confirm="setValue(row, cell, $event)"
                                             :autocomplete="aliquotaAutocomplete" class="next-vue-multiselect-single"
                                             placeholder="Aliquota" titolo="Aliquota" track-by="id" label="descrizione">
                                </DynamicCell>
                            </template>

                            <template v-for="(c, j) in s.ordered_records" :key="j"
                                      v-slot:[`td_${j}_ve_valuta`]="{ row, cell }">
                                <DynamicCell :modelValue="getValue(row, cell)" :is_component="getComponent(row, cell)"
                                             :autocomplete="customValutaAutocomplete" v-bind="getProps(row, cell)"
                                             @confirm="setValue(row, cell, $event)" titolo="Valuta di vendita">
                                    <template v-slot:cell="{ value }">
                                        <template v-if="value">
                                            <span>{{
                                                    `${value.descrizione} - 1 ${value.valuta?.CG08_SIGLA} =
                                                ${value.valore} €`
                                                }}</span>
                                        </template>
                                    </template>
                                    <template v-slot:main="option">
                                        <VueMultiselect :options="customValutaAutocomplete.options"
                                                        v-model="customValutaAutocomplete.selection"
                                                        :loading="customValutaAutocomplete.isLoading"
                                                        @update:modelValue="option.setInternalValue($event)"
                                                        @search-change="customValutaAutocomplete.search"
                                                        class="next-vue-multiselect-single overflow-ellipsis mb-3"
                                                        :close-on-select="true" :clear-on-select="false"
                                                        deselectLabel="Deseleziona"
                                                        selectedLabel="Selezionato" selectLabel="Seleziona"
                                                        track-by="id"
                                                        placeholder="Valuta di vendita">
                                            <template v-slot:noResult>Nessun elemento trovato.</template>
                                            <template v-slot:singleLabel="{ option }">
                                                {{
                                                    `${option.descrizione} - 1 ${option.valuta?.CG08_SIGLA} =
                                                ${option.valore} €`
                                                }}
                                            </template>
                                            <template v-slot:option="{ option }">
                                                {{
                                                    `${option.descrizione} - 1 ${option.valuta?.CG08_SIGLA} =
                                                ${option.valore} €`
                                                }}
                                            </template>
                                        </VueMultiselect>
                                    </template>
                                </DynamicCell>
                            </template>


                            <template v-for="(c, j) in s.ordered_records" :key="j"
                                      v-slot:[`td_${j}_ve_aliquota`]="{ row, cell }">
                                <DynamicCell :modelValue="getValue(row, cell)" :is_component="getComponent(row, cell)"
                                             v-bind="getProps(row, cell)" @confirm="setValue(row, cell, $event)"
                                             :autocomplete="aliquotaAutocomplete" class="next-vue-multiselect-single"
                                             placeholder="Aliquota" titolo="Aliquota di vendita" track-by="id"
                                             label="descrizione">
                                </DynamicCell>
                            </template>

                            <template v-for="(c, j) in s.ordered_records" :key="j"
                                      v-slot:[`td_${j}_ve_fee`]="{ row, cell }">
                                <DynamicCell :modelValue="getValue(row, cell)" :is_component="getComponent(row, cell)"
                                             v-bind="getProps(row, cell)" titolo="Fee">
                                    <template v-slot:cell="{ value }">
                                        <template v-if="value">
                                            {{ `${value?.descrizione} - ${value?.valore}%` }}
                                        </template>
                                    </template>
                                    <template #main>
                                        <VueMultiselect :modelValue="getValue(row, cell)"
                                                        @update:modelValue="setValue(row, cell, $event)"
                                                        :options="dati.fee"
                                                        :close-on-select="true" :clear-on-select="false"
                                                        placeholder="Fee"
                                                        class="mb-3 next-vue-multiselect-single"
                                                        deselectLabel="Deseleziona"
                                                        selectedLabel="Selezionato" selectLabel="Seleziona"
                                                        track-by="id"
                                                        label="descrizione">
                                        </VueMultiselect>
                                    </template>
                                </DynamicCell>
                            </template>

                        </NextSottoProgettoTable>
                    </SezioneSottoProgetti>
                </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Topbar from "../components/Topbar.vue";
import InfiniteLoading from "v3-infinite-loading";
import ContextMenu from "@/components/ContextMenu.vue";
import sottoProgettiManager from "../api/SottoProgetti";
import ModalSottoProgetto from "@/components/ModalSottoProgetto.vue";
import NextSottoProgettoTable from "@/components/NextSottoProgettoTable.vue";
import SezioneSottoProgetti from "@/components/SezioneSottoProgetti.vue";
import meManager from "../api/Me";
import {Paths, StatiSottoprogetto, TipoRigaPreventivo} from "@/types";
import ModalEsportaSottoprogetto from "@/components/EsportaSottoprogetto.vue";
import ConfirmDelete from "@/components/ConfirmDelete.vue";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import {mapActions, mapGetters, mapState} from 'vuex';
import Autocomplete from "@/setup/Autocomplete";
import fornitoriManager from "../api/FornitoriManager";
import voceSpesaManager from "../api/VoceSpesaManager";
import aliquotaManager from "../api/AliquotaManager";
import Text from "@/components/Text.vue";
import NextButton from "@/components/NextButton.vue";
import DynamicCell from "@/components/DynamicCell.vue";
import ModalInput from "@/components/ModalInput.vue";
import CardDivisorioGrigio from "@/components/CardDivisorioGrigio.vue";
import ToolbarSottoProgetto from "@/components/ToolbarSottoProgetto.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import AzioniSottoProgetto from "@/components/AzioniSottoProgetto.vue";
import Tabs from "@/components/Tabs.vue";
import OffertaContextMenu from "@/components/OffertaContextMenu.vue";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import SottoProgettoHead from "@/views/SottoProgettoHead.vue";
import BadgeStato from "@/components/BadgeStato.vue";
import HidingToolbar from "@/components/HidingToolbar.vue";
import {reactive} from 'vue';
import MultiselectOption from "@/components/MultiselectOption.vue";
import clientiManager from "../api/Clienti";
import LocalAutocompleteManager from "../api/LocalAutocompleteManager";
import {v4 as uuidv4} from 'uuid';
import progettiManager from "../api/Progetti";
import Alert from "@/components/Alert.vue";
import SelectStato from "@/components/SelectStato.vue";
import ModalFeesDetail from "@/components/ModalFeesDetail.vue";
import Modal from "@/components/Modal.vue";
import FileUpload from "@/components/FileUpload.vue";
import Field from "@/components/Field.vue";
import filesManager from "../api/File";
import Spinner from "@/components/Spinner.vue";
import Checkbox from "@/components/Checkbox.vue";
import ModalCaricaExcel from "@/components/ModalCaricaExcel.vue";
import Radio from '@/components/Radio.vue';
import {nazioneManager} from "../api/Citta";

@Options({
    name: 'DettaglioSottoProgetto',
    components: {
        ModalCaricaExcel,
        Checkbox,
        Spinner,
        Field,
        FileUpload,
        Modal,
        ModalFeesDetail,
        SelectStato,
        Alert,
        ModalInput,
        MultiselectOption,
        BadgeStato,
        SottoProgettoHead,
        OffertaContextMenu,
        Tabs,
        ToolbarSottoProgetto,
        AzioniSottoProgetto,
        CardDivisorioGrigio,
        DynamicCell,
        NextButton,
        Topbar,
        NextSottoProgettoTable,
        ContextMenu,
        InfiniteLoading,
        ModalSottoProgetto,
        ModalEsportaSottoprogetto,
        SezioneSottoProgetti,
        ConfirmDelete,
        Breadcrumbs,
        HidingToolbar,
        Text,
        Radio
    },
    inject: ['getColoreStato', 'getLabelStato', "downloadFile"],
    props: {
        id: String,
        readonly: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        StatiSottoprogetto() {
            return StatiSottoprogetto
        },
        ...mapState('buFieldModule', {
            sottoProgettiCols: (state: any) => state.sottoProgettiCols
        }),
        ...mapGetters('buFieldModule', [
            'tableHeader',
            'computedUserPreference',
            'sortedAllField',
            'OrderedRows',
        ]),
        ...mapGetters('sprjDataManager', [
            'AcCostoUnitarioNetto',
            'AcCostoTotale',
            'AcCostoTotaleEuro',
            'AcCostoUnitarioEuro',
            'AcCostoTotaleRisorsa',
            // 'VeCostoTotaleRisorsa',
            'AcCommissioneTotale',
            'AcCommissioneTotaleEuro',
            'VeBudget',
            'VeBudgetEuro',
            'BudgetLordoIva',
            'Mol',
            'Utile',
            'CostoVenditaUnitario',
            'TotaleCostiEuroProgetto',
            'TotaleCostoRisorseProgetto',
            'TotaleUtiliProgetto',
            'TotaleUtiliProgettoConFee',
            'TotaleRicaviProgetto',
            'TotaleBudgetProgettoConFee',
            'TotaleCommissioniProgetto',
            'TotaleRisorseInterne',
            'TotaleMol',
            'TotaleBudgetProgetto',
            'TotaleRicaviProgettoConFee',
            'TotaleCostiEuroSezione',
            'TotaleBudgetProgettoSezione',
            'TotaleUtileEuroSezione',
            'TotaleMolSezione',
            'TotaleFeesSezione',
            'TotaleMolProgetto',
            'TotaleMolProgettoConFee',
            'TotaleOreRisorseProgetto',
            'StessaValutaVendita',
            'TotaleFees',
            'TotaleFeesSezioni',
            'Sottoprogetto',
            'StatiOfferta',
            'Tipologia',
            'isDescrizione',
            'isOpzionale',
        ]),
    },
    methods: {
        ...mapActions('buFieldModule', [
            'fetchSottoprogettoUserPreference',
            'updateTableHeader',
            'toggleFieldVisibility',
            'orderChange',
        ]),
        ...mapActions('sprjDataManager', [
            'setValute',
            'setFees',
            'setSottoprogetto',
            'setDatiSottoprogetto',
        ])
    }
})
export default class DettaglioSottoProgetto extends Vue {
    AcCostoUnitarioNetto: any
    tableHeader: any
    StatiOfferta: any
    Tipologia: any
    AcCostoTotale: any
    AcCostoTotaleEuro: any
    AcCostoUnitarioEuro: any
    AcCostoTotaleRisorsa: any
    // VeCostoTotaleRisorsa: any
    AcCommissioneTotaleEuro: any
    VeBudget: any
    VeBudgetEuro: any
    setSottoprogetto: any
    setDatiSottoprogetto: any
    BudgetLordoIva: any
    Mol: any
    Utile: any
    CostoVenditaUnitario: any
    TotaleCostiEuroProgetto: any
    TotaleCommissioniProgetto: any
    TotaleFees: any
    TotaleBudgetProgettoSezione: any
    TotaleCostiEuroSezione: any
    TotaleUtileEuroSezione: any
    TotaleMolSezione: any
    TotaleFeesSezione: any
    TotaleUtiliProgetto: any
    TotaleUtiliProgettoConFee: any
    TotaleRicaviProgetto: any
    TotaleBudgetProgettoConFee: any
    TotaleMolProgetto: any
    TotaleMolProgettoConFee: any
    StessaValutaVendita: any
    isDescrizione: any
    isOpzionale: any
    getLabelStato: any
    show_fee_detail = false
    accordo_quadro = false

    id!: number | string
    topbar = Topbar

    fornitoreAutocomplete: any = setup(() => Autocomplete(fornitoriManager, false, {validi: 1}))
    vocespesaAutocomplete: any = setup(() => Autocomplete(voceSpesaManager))
    aliquotaAutocomplete: any = setup(() => Autocomplete(aliquotaManager))

    customValutaManager = new LocalAutocompleteManager()
    customValutaAutocomplete: any = setup(() => Autocomplete(this.customValutaManager))
    clienteAutocomplete: any = setup(() => Autocomplete(clientiManager))
    cmOpener: any = setup(() => ContextMenuOpener())
    paeseAutocomplete: any = setup(() => Autocomplete(nazioneManager))

    modal_allegato_stato = false
    show_carica_excel = false
    uploaded_files: any = []
    model_files = []
    to_delete = []
    modal_stato_errors: any = {}
    stato_before_change!: number | null;
    loading_cambio_stato = false;
    allegato_sottoprogetto: any = null;

    nota = ""
    tags = []
    infoPolicy = ""
    dataOfferta = ""
    terminiPagamento = ""
    sconto = 0

    salvataggio_pendente: any = 0
    errore_salvataggio = ''
    prevent_autosave = true
    cm_visible = false
    sottoprogetto_model: any = {
        stato: null,
        titolo: null,
        business_unit_id: 0,
        cliente_id: 0,
        data_inizio: null,
        data_fine: null,
        budget: null,
        totale_costi: null,
        risorse_interne: null,
        totale_ricavi: null,
        utile: null,
        margine: null
    }

    progetto_model: any = null
    private getVisibleField: any;
    private setValute: any;
    private setFees: any;
    private sottoProgettiCols: any;
    private expandend = true;
    private user_preference_timeout = 0;

    get defaultFee(): any {
        const idx = this.dati.fee.findIndex((el: any) => el.default);
        return idx >= 0 ? idx : undefined
    }

    get defaultAc() {
        const idx = this.dati.valute.findIndex((el: any) => el.default_acq)
        return idx >= 0 ? idx : undefined
    }

    get defaultVe() {
        const idx = this.dati.valute.findIndex((el: any) => el.default_ve);
        return idx >= 0 ? idx : undefined
    }

    get defaultMarkUp() {
        return this.dati.default_markup
    }

    get getBreadcrumbsPath() {
        return [
            {
                title: 'Progetti',
                name: 'ListaProgetti',
            },
            {
                title: 'Progetto',
                name: 'DettaglioProgetto',
                params: {id: this.sottoprogetto_model.progetto_id || 0}
            },
            {
                title: 'Dettaglio sottoprogetto',
                name: 'DettaglioSottoProgetto',
            },
        ]
    }

    created() {
        this.cmOpener.position = 'top-left'
    }

    hasNuvole(row: any) {
        return row.nuvole
    }

    isText(component: string) {
        return component === 'Text'
    }

    cancellaSezione(idx: number) {
        this.ActiveTab.sezioni.splice(idx, 1)
        this.autoVersionaSottoprogetto()
    }

    cancellaRecord(sec: any, c: any) {
        this.cmOpener.close()
        const idx = sec.records.indexOf(c)
        if (idx > -1) {
            sec.records.splice(idx, 1)
        }
        this.updateSectionData()
        this.autoVersionaSottoprogetto()
    }

    duplicaRecord(sec: any, c: any) {
        this.cmOpener.close()
        const record = {...JSON.parse(JSON.stringify(c)), id: uuidv4()}
        if (record.nuvole?.length) {
            record.nuvole.forEach((e: any) => {
                e.id = uuidv4()
            })
        }
        if (record.alternative?.length) {
            record.alternative.forEach((e: any) => {
                e.id = uuidv4()
            })
        }
        sec.records.push(record)
        this.updateSectionData()
        this.autoVersionaSottoprogetto()
    }

    eliminaSottoriga(section: any, sottoriga: any) {
        this.cmOpener.close();
        //elimina la sottoriga
        if (sottoriga._nuvola) {
            section.records.some((r: any) => {
                let index = -1
                if (r.nuvole) {
                    index = r.nuvole.indexOf(sottoriga)
                }
                if (index > -1) {
                    r.nuvole.splice(index, 1)
                    if (!r.nuvole.length) {
                        delete r.nuvole
                    }
                    return true
                }
            })
        } else if (sottoriga._alternativa) {
            section.records.some((r: any) => {
                let index = -1
                if (r.alternative) {
                    index = r.alternative.indexOf(sottoriga)
                }
                if (index > -1) {
                    r.alternative.splice(index, 1)
                    if (!r.alternative.length) {
                        delete r.alternative
                    }
                    return true
                }
            })
        }

        this.updateSectionData()
    }

    duplicaSottoriga(section: any, sottoriga: any) {
        this.cmOpener.close();
        // se la sottoriga è una nuvola cerco in quale riga è e la duplico
        if (sottoriga._nuvola) {
            section.records.some((r: any) => {
                let index = -1
                if (r.nuvole) {
                    index = r.nuvole.indexOf(sottoriga)
                }
                if (index > -1) {
                    r.nuvole.push({...JSON.parse(JSON.stringify(sottoriga)), id: uuidv4()})
                    return true
                }
            })
        } else if (sottoriga._alternativa) {
            section.records.some((r: any) => {
                let index = -1
                if (r.alternative) {
                    index = r.alternative.indexOf(sottoriga)
                }
                if (index > -1) {
                    r.alternative.push({...JSON.parse(JSON.stringify(sottoriga)), id: uuidv4()})
                    return true
                }
            })
        }

        this.updateSectionData()
    }

    toggleExpand(s: any) {
        return new Promise((resolve, reject) => {
            if (s) {
                s.expanded = !s.expanded
            } else {
                this.expandend = !this.expandend
                this.dati.tabs.forEach((t) => {
                    t.sezioni.forEach((s) => {
                        s.expanded = this.expandend
                    })
                })
            }
            resolve(undefined)
        })
    }

    preventSaveOnToggleExpand(s: any) {
        this.preventSaveExec(() => this.toggleExpand(s))
    }

    openToolbar($value: number) {
        this.azioni_visible = true
        this.tabindex = $value
    }

    addNuvola(c: any) {
        if (!c.nuvole) {
            const d = JSON.parse(JSON.stringify(c))
            c.nuvole = []
            c.nuvole.push({
                ...d,
                type: TipoRigaPreventivo.OFFERTA,
                _nuvola: true,
                id: uuidv4(),
                ve_fee: this.defaultFee,
                ac_valuta: this.defaultAc,
                ve_valuta: this.defaultVe,
                ac_mark_up: this.defaultMarkUp
            })
        } else {
            c.nuvole.push({
                type: TipoRigaPreventivo.OFFERTA,
                _nuvola: true,
                id: uuidv4(),
                ve_fee: this.defaultFee,
                ac_valuta: this.defaultAc,
                ve_valuta: this.defaultVe,
                ac_mark_up: this.defaultMarkUp
            })
        }
        c.type = TipoRigaPreventivo.OFFERTA
        this.updateSectionData()
    }

    addAlternativa(c: any) {
        if (!c.alternative) {
            c.alternative = []
        }
        c.alternative.push({
            type: TipoRigaPreventivo.OFFERTA,
            _alternativa: true,
            id: uuidv4(),
            ve_fee: this.defaultFee,
            ac_valuta: this.defaultAc,
            ve_valuta: this.defaultVe,
            ac_mark_up: this.defaultMarkUp
        })
        c.type = TipoRigaPreventivo.OFFERTA
        this.updateSectionData()
    }

    toggleDescrizione(c: any) {
        switch (c.type) {
            case TipoRigaPreventivo.DESCRIZIONE:
                c.type = TipoRigaPreventivo.OFFERTA
                break
            default:
                c.type = TipoRigaPreventivo.DESCRIZIONE
                break;
        }
        if (this.isDescrizione(c)) {
            delete c.nuvole
            delete c.alternative
        }
    }

    toggleOpzionale(c: any) {
        switch (c.type) {
            case TipoRigaPreventivo.OPZIONALE:
                c.type = TipoRigaPreventivo.OFFERTA
                break
            default:
                c.type = TipoRigaPreventivo.OPZIONALE
                break;
        }
        if (this.isOpzionale(c)) {
            delete c.nuvole
            delete c.alternative
        }
    }

    preventSaveExec(fun: any): any {
        this.prevent_autosave = true;
        return fun().then(() => {
            //previene il salvataggio sul caricamento dello stato iniziale
            this.$nextTick(() => {
                this.prevent_autosave = false
            })
        })
    }

    reloadExcelImport() {
        this.preventSaveExec(() => {
            return this.refresh().then(() => {
                this.updateSectionData()
                //@ts-ignore
                this.fetchSottoprogettoUserPreference(this.id)
            })
        })
    }

    mounted() {
        this.preventSaveExec(() => {
            return this.refresh().then(() => {
                this.updateSectionData()
                //@ts-ignore
                this.fetchSottoprogettoUserPreference(this.id)
            })
        })
    }

    reloadAllegatoAperturaProgetto() {
        if (this.sottoprogetto_model.richiesta_apertura_file_id) {
            filesManager.file(this.sottoprogetto_model.richiesta_apertura_file_id).then((res) => {
                this.allegato_sottoprogetto = res.data
            })
        }
    }

    refresh() {
        return sottoProgettiManager.sottoprogetto(this.id).then((res) => {
            this.sottoprogetto_model = res.data
            this.vocespesaAutocomplete.addAjaxParam('bu', this.sottoprogetto_model.business_unit_id)
            this.dati = {...this.dati, ...JSON.parse(res.data.ultimi_dati)}
            this.infoPolicy = this.dati.policy.infoPolicy
            this.terminiPagamento = this.dati.policy.terminiPagamento
            this.dataOfferta = this.dati.policy.dataOfferta
            this.sconto = this.dati.sconto
            this.onUpdateValute(this.dati.valute)
            this.onUpdateFees(this.dati.fee)
            this.setDatiSottoprogetto(this.dati)
            this.reloadAllegatoAperturaProgetto()
            return Promise.all([sottoProgettiManager.gamma(this.id), progettiManager.progetto(this.sottoprogetto_model.progetto_id)])
        }).then(([res_gamma, res_prog]: any[]) => {
            this.progetto_model = res_prog.data
            this.sottoprogetto_model.stato = res_gamma.data.PD0C_STATO_PD1E
        })
    }

    updateSectionData() {
        this.ActiveTab.sezioni.forEach((s) => {
            //@ts-ignore
            let a = this.OrderedRows(s.records)
            s.ordered_records = a
        })
    }

    performOrder(cols: string) {
        //@ts-ignore
        this.orderChange(cols).then(() => {
            this.updateSectionData()
        })
    }

    getValue(row: any, cell: any) {
        switch (cell.prop) {
            case 'ac_costo_unitario_netto':
                return this.AcCostoUnitarioNetto(row).toCurrencyString()
            case 'ac_costo_totale':
                return this.AcCostoTotale(row).toCurrencyString()
            case 'ac_costo_totale_e':
                return this.AcCostoTotaleEuro(row).toCurrencyString()
            case 'ac_costo_unitario_e':
                return this.AcCostoUnitarioEuro(row).toCurrencyString()
            case 'ac_costo_totale_risorsa_interna':
                return this.AcCostoTotaleRisorsa(row).toCurrencyString()
            // case 've_costo_totale_risorsa_interna':
            //     return this.VeCostoTotaleRisorsa(row).toCurrencyString()
            case 'ac_totale_commissioni':
                return this.AcCommissioneTotaleEuro(row).toCurrencyString()
            case 've_budget':
                return this.VeBudget(row).toCurrencyString()
            case 've_budget_lordo_iva':
                return this.BudgetLordoIva(row).toCurrencyString()
            case 're_utile':
                return this.Utile(row).toCurrencyString()
            case 've_vendita_unitario':
                return this.CostoVenditaUnitario(row)
            case 've_budget_e':
                return this.VeBudgetEuro(row).toCurrencyString()
            case 're_mol':
                // eslint-disable-next-line no-case-declarations
                const v = this.Mol(row)
                return `${(v ? v : 0).toCurrencyString() || ''}`
            case 'ac_valuta':
                return this.getValutaAcquisto(row)
            case 've_valuta':
                return this.getValutaVendita(row)
            case 've_fee':
                return this.getFee(row)
        }
        return row[cell.prop]
    }


    setValue(row: any, cell: any, value: any) {
        const old_value = row[cell.prop]
        switch (cell.prop) {
            case 'ac_valuta':
            case 've_valuta':
            case 've_fee':
                row[cell.prop] = value ? value.id : value
                break
            default:
                row[cell.prop] = value
        }
        this.customWatch(row, cell, value, old_value)
    }

    customWatch(row: any, cell: any, newValue: any, oldValue: any) {
        switch (cell.prop) {
            case 'ne_voce_spesa':
                voceSpesaManager.voceSpesaDefaultIva(newValue.id, this.sottoprogetto_model.business_unit_id).then((res) => {
                    if (!row['ac_aliquota']) {
                        row['ac_aliquota'] = res.data.iva_acquisto
                    }
                    if (!row['ve_aliquota']) {
                        row['ve_aliquota'] = res.data.iva_vendita
                    }
                })
                this.vocespesaAutocomplete.empty()
                break
            case 'ac_valuta':
            case 've_valuta':
                this.customValutaAutocomplete.empty()
                break
            case 'ac_aliquota':
            case 've_aliquota':
                this.aliquotaAutocomplete.empty()
                break
            case 'ne_fornitore':
                this.fornitoreAutocomplete.empty()
                break
            case 'ac_unita':
                if (row['ve_unita'] == undefined || row['ve_unita'] == oldValue) {
                    row['ve_unita'] = newValue
                }
                break
            case 'ac_ovn_gg':
                if (row['ve_ovn_gg'] == undefined || row['ve_ovn_gg'] == oldValue) {
                    row['ve_ovn_gg'] = newValue
                }
                break
            case 'ac_qta':
                if (row['ve_qta'] == undefined || row['ve_qta'] == oldValue) {
                    row['ve_qta'] = newValue
                }
                break
        }
    }

    modal_stato: any = {
        descrizione: null,
        paese_id: null,
        numero_pax: null,
        citta: null,
    }

    dati = {
        fee: [],
        policy: {
            infoPolicy: "",
            dataOfferta: "",
            terminiPagamento: ""
        },
        rebate: [],
        valute: [],
        default_markup: 0,
        budget_consuntivo: 0,
        sconto: 0,
        totale_costi: 0,
        risorse_interne: 0,
        totale_ricavi: 0,
        utile: 0,
        margine: 0,
        active_tab: 0,
        tabs: [
            {
                titolo: 'Nuovo tab',
                sezioni: [
                    {
                        titolo: '',
                        expanded: true,
                        records: [{}],
                        ordered_records: [{}]
                    },
                ]
            },
        ]
    }

    addTab(data: any) {
        if (data) {
            this.dati.tabs.push(data)
        } else {
            this.dati.tabs.push({
                'titolo': 'Nuovo tab',
                sezioni: [
                    {
                        titolo: '',
                        expanded: true,
                        records: [reactive({})],
                        ordered_records: []
                    }
                ]
            })
        }
        this.dati.active_tab = this.dati.tabs.length - 1
        this.updateSectionData()
    }

    removeTab(i: number) {
        if (this.dati.tabs.length > 1) {
            if (this.dati.active_tab >= this.dati.tabs.length - 1) {
                this.dati.active_tab -= 1
            }
            this.dati.tabs.splice(i, 1)
        }
    }

    onTabEditing(val: boolean) {
        this.prevent_autosave = val
        if (!val) {
            this.autoVersionaSottoprogetto()
        }
    }

    duplicaTab(i: number) {
        this.addTab(JSON.parse(JSON.stringify(this.dati.tabs[i])))
    }


    handleOrderUp(sezioni: any[], idx: number) {
        if (0 < idx && idx < sezioni.length) {
            sezioni.splice(idx - 1, 0, ...sezioni.splice(idx, 1))
        }
    }

    handleOrderDown(sezioni: any[], idx: number) {
        if (0 <= idx && idx < sezioni.length - 1) {
            sezioni.splice(idx + 1, 0, ...sezioni.splice(idx, 1))
        }
    }

    @Watch('dati.tabs', {deep: true})
    @Watch('dati.policy', {deep: true})
    @Watch('dati.fee')
    @Watch('dati.sconto')
    @Watch('dati.rebate')
    @Watch('dati.valute')
    @Watch('dati.active_tab')
    autosave(old_val: any, new_val: any) {
        if (!this.prevent_autosave) {
            this.autoVersionaSottoprogetto()
        }
    }

    versionamentoManuale() {
        if (!this.prevent_autosave) {
            this.errore_salvataggio = ''
            sottoProgettiManager.versionaManualmente(this.id, {
                dati: JSON.stringify({...this.dati}),
                tags: JSON.stringify(this.tags),
                nota: this.nota
            }).then((res) => {
                this.setSottoprogetto(this.sottoprogetto_model)
                this.sottoprogetto_model.last_major = res.data.major
                this.sottoprogetto_model.last_minor = res.data.minor
                this.azioni_visible = false
                this.waiting = false
                this.nota = ''
                this.tags = []
            }).catch((res) => {
                if (res?.response?.data?.error) {
                    this.errore_salvataggio = res.response.data.error
                }
            })
        }
    }

    savePolicy() {
        this.dati.policy.infoPolicy = this.infoPolicy
        this.dati.policy.terminiPagamento = this.terminiPagamento
        this.dati.policy.dataOfferta = this.dataOfferta
        this.azioni_visible = false
        this.waiting = false
    }

    saveSconto() {
        this.dati.sconto = this.sconto
        this.azioni_visible = false
        this.waiting = false
    }

    importSottoprogetto({sottoprogetto, versione}: any) {
        this.waiting = true
        sottoProgettiManager.importFrom(this.id, sottoprogetto.id, versione.id).then((res) => {
            this.preventSaveExec(() => {
                return this.refresh().then(() => {
                    this.updateSectionData()
                    //@ts-ignore
                    this.fetchSottoprogettoUserPreference(this.id)
                })
            })
        }).finally(() => {
            this.azioni_visible = false
            this.waiting = false
        })

    }

    autoVersionaSottoprogetto() {
        clearTimeout(this.salvataggio_pendente)
        this.salvataggio_pendente = setTimeout(() => {
            this.versionamentoAutomatico()
        }, 2000)
    }

    performCambioStatoWithFile() {
        this.loading_cambio_stato = true
        this.performCambioStato(this.stato_before_change, this.uploaded_files[0]?.id, this.accordo_quadro).then(() => {
            this.stato_before_change = null
            this.modal_allegato_stato = false
        }).catch((res) => {
            if (res.response.status == 422) {
                this.modal_stato_errors = res.response.data.errors
            }
        }).finally(() => {
            this.loading_cambio_stato = false
        })
    }

    modalFileError(upload_errors: any) {
        let errors: string[] = []
        if (upload_errors['file_id']) {
            errors = [...errors, ...upload_errors['file_id']]
        }
        Object.keys(upload_errors).filter(value => /^assets/.test(value)).forEach((e) => {
            errors = [...errors, ...upload_errors[e]]
        })
        return errors
    }

    changeSottoprogettoStato(value: any) {
        if (value.PD1E_CODICE == StatiSottoprogetto.RICHIESTA_APERTURA) {
            this.stato_before_change = value.id
            this.modal_allegato_stato = true
            this.popolateStatoModalValue()
        } else {
            this.stato_before_change = null
            this.performCambioStato(value.id, undefined, false)
        }
    }

    popolateStatoModalValue() {
        this.modal_stato.descrizione = this.sottoprogetto_model.descrizione
        this.modal_stato.paese_id = this.sottoprogetto_model.paese_id
        this.paeseAutocomplete.retrieve(this.sottoprogetto_model.paese_id)
        this.modal_stato.numero_pax = this.sottoprogetto_model.numero_pax
        this.modal_stato.citta = this.sottoprogetto_model.citta
    }

    performCambioStato(value_id: any, file_id?: number, accordo_quadro?: boolean) {
        return sottoProgettiManager.cambiaStato(this.id, {
            stato: value_id,
            dati: JSON.stringify(this.dati),
            file_id: file_id,
            accordo_quadro: accordo_quadro,
            descrizione: this.modal_stato.descrizione,
            paese_id: this.paeseAutocomplete.selection?.id,
            numero_pax: this.modal_stato.numero_pax,
            citta: this.modal_stato.citta,
        }).then(() => {
            this.preventSaveExec(() => {
                return this.refresh()
            })
        })
    }

    applicaAtutti(row: any, key: string, valore: any) {
        row[key] = valore
    }

    onApplicaMarkUpATutti({mk, section}: any) {
        let sections = this.ActiveTab.sezioni
        if(section){
            sections = [sections[section.id]]
        }
        sections.forEach((s: any) => {
            s.records.forEach((r: any) => {
                this.applicaAtutti(r, 'ac_mark_up', mk)
                if (r.nuvole?.length) {
                    r.nuvole.forEach((e: any) => {
                        this.applicaAtutti(e, 'ac_mark_up', mk)
                    })
                }
                if (r.alternative?.length) {
                    r.alternative.forEach((e: any) => {
                        this.applicaAtutti(e, 'ac_mark_up', mk)
                    })
                }
            })
        })
    }

    versionamentoAutomatico() {
        this.errore_salvataggio = ''
        sottoProgettiManager.autoversiona(this.id, {
            dati: JSON.stringify(this.dati)
        }).then((res) => {
            this.setSottoprogetto(this.sottoprogetto_model)
            this.sottoprogetto_model.last_major = res.data.major
            this.sottoprogetto_model.last_minor = res.data.minor
            this.salvataggio_pendente = 0
        }).catch((res) => {
            this.salvataggio_pendente = 0
            if (res?.response?.data?.error) {
                this.errore_salvataggio = res.response.data.error
            }
        })
    }

    isMarkUpOrArrotondamentoSet(row: any) {
        // casto a booleano altrimenti non va
        return row['ac_mark_up']?.length || row['ac_arrotondamento_costo_unitario']?.length || false
    }

    getValutaAcquisto(row: any): any {
        return this.dati.valute.find((el: any) => el.id == row['ac_valuta'])
    }

    getValutaAcquistoValore(row: any): any {
        return this.getValutaAcquisto(row)?.valore || 1
    }

    getValutaVendita(row: any): any {
        return this.dati.valute.find((el: any) => el.id == row['ve_valuta'])
    }

    getFee(row: any): any {
        return this.dati.fee.find((el: any) => el.id == row['ve_fee'])
    }

    getValutaVenditaValore(row: any): any {
        return this.getValutaVendita(row)?.valore || 1
    }

    getValutaVenditaFirstChar(row: any) {
        const valuta = this.getValutaVendita(row)
        return valuta?.valuta?.CG08_SIGLA || '€'
    }

    getValutaAcquistoFirstChar(row: any) {
        const valuta = this.getValutaAcquisto(row)
        return valuta?.valuta?.CG08_SIGLA || '€'
    }

    getStatoOffertaColor(row: any) {
        const stato = row['ne_stato']
        switch (stato?.id) {
            case 0:
                return "text-next-pre"
            case 1:
                return "text-next-orange"
            case 2:
                return "text-next-bri"
        }
        return ""
    }

    getProps(row: any, cell: any) {
        switch (cell.prop) {
            case 'ne_descrizione_servizio':
                return {
                    inputClass: "absolute inset-0 bg-white cursor-pointer truncate",
                }
            case 'ne_titolo':
                return {
                    type: 'text',
                    class: 'h-6 w-full'
                }
            case 'ne_fornitore':
                return {
                    inputClass: "absolute inset-0 bg-next-acquisto cursor-pointer truncate",
                }
            case 'ne_stato':
            case 'ne_tipologia':
            case 'ne_voce_spesa':
                return {
                    inputClass: "absolute inset-0 bg-white cursor-pointer truncate",
                }
            case 'ac_costo_unitario_netto':
            case 'ac_costo_totale':
                return {
                    type: 'text',
                    disabled: 'true',
                    class: 'w-full bg-next-acquisto text-right pr-10',
                    wrapperPost: this.getValutaAcquistoFirstChar(row)
                }
            case 'ac_costo_unitario_e':
            case 'ac_costo_totale_e':
            case 'ac_totale_commissioni':
                return {
                    type: 'text',
                    disabled: 'true',
                    class: 'w-full bg-next-acquisto text-right pr-10',
                    wrapperPost: '€'
                }
            case 'ac_costo_unitario':
                // disabilito il campo se ho settato il fornitore a risorsa interna
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-acquisto text-right pr-10 w-full',
                    wrapperPost: this.getValutaAcquistoFirstChar(row)
                }
            case 'ac_costo_unitario_risorsa_interna':
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-acquisto text-right pr-10 w-full',
                    wrapperPost: '€'
                }
            case 'ac_costo_totale_risorsa_interna':
                return {
                    disabled: true,
                    class: 'bg-next-acquisto text-right pr-10 w-full',
                    wrapperPost: '€'
                }
            case 've_costo_unitario':
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-acquisto text-right'
                }
            case 'ac_unita':
            case 'ac_qta':
                return {
                    min: 0,
                    type: 'number',
                    step: '1',
                    class: 'bg-next-acquisto text-right w-full'
                }
            case 'ac_unita_descrizione':
            case 'ac_ovn_gg_descrizione':
            case 'ac_qta_descrizione':
                return {
                    class: 'bg-next-acquisto w-full'
                }
            case 've_budget':
                return {
                    disabled: true,
                    class: 'bg-next-vendita text-right pr-10 w-full',
                    wrapperPost: this.getValutaVenditaFirstChar(row)
                }
            case 've_budget_e':
                return {
                    disabled: true,
                    class: 'bg-next-vendita w-full text-right pr-10',
                    wrapperPost: '€'
                }
            case 've_storico':
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'text-right pr-10 w-full',
                    wrapperPost: this.getValutaVenditaFirstChar(row)
                }
            case 've_budget_lordo_iva':
                return {
                    disabled: true,
                    class: 'bg-next-vendita text-right pr-10 w-full',
                    wrapperPost: '€'
                }
            case 've_unita':
            case 've_qta':
                return {
                    min: 0,
                    type: 'number',
                    step: '1',
                    class: 'bg-next-vendita text-right w-full'
                }
            case 've_unita_descrizione':
            case 've_ovn_gg_descrizione':
            case 've_qta_descrizione':
                return {
                    class: 'bg-next-vendita w-full'
                }
            case 'ac_ovn_gg':
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-acquisto text-right w-full'
                }
            case 've_ovn_gg':
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-vendita text-right w-full'
                }
            case 'ac_commissione':
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-acquisto text-right pr-10 w-full',
                    wrapperPost: '%'
                }
            case 'ac_valuta':
            case 'ac_aliquota':
                return {
                    inputClass: "absolute inset-0 cursor-pointer bg-next-acquisto truncate",
                }
            case 've_valuta':
                return {
                    inputClass: "absolute inset-0 cursor-pointer bg-next-vendita truncate",
                }
            case 've_aliquota':
            case 've_fee':
                return {
                    inputClass: "absolute inset-0 cursor-pointer bg-next-vendita truncate",
                }
            case 'ac_mark_up':
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-acquisto text-right w-full pr-8',
                    wrapperPost: '%'
                }
            case 'ac_arrotondamento_costo_unitario':
                return {
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-acquisto w-full text-right w-full'
                }
            case 'ac_note_interne':
                return {
                    class: 'bg-next-acquisto w-full'
                }
            case 've_note':
                return {
                    class: 'bg-next-vendita w-full'
                }
            case 've_vendita_unitario':
                return {
                    disabled: this.isMarkUpOrArrotondamentoSet(row),
                    min: 0,
                    type: 'number',
                    step: '0.01',
                    class: 'bg-next-vendita text-right pr-10 w-full',
                    wrapperPost: this.getValutaVenditaFirstChar(row)
                }
            case 're_mol':
                return {
                    disabled: true,
                    type: 'text',
                    class: 'text-right pr-10 w-full ' + this.reColor(row),
                    wrapperPost: '%'
                }
            case 're_utile':
                return {
                    disabled: true,
                    type: 'text',
                    class: 'text-right pr-10 w-full ' + this.reColor(row),
                    wrapperPost: '€'

                }
            default:
                return {}
        }
    }

    reColor(row: any) {
        if (this.Mol(row) > 0) {
            return 'bg-next-margine'
        }
        if (this.Mol(row) < 0) {
            return 'bg-next-acquisto'
        }
        return 'bg-next-gray-md'
    }

    getComponent(row: any, cell: any) {
        if (this.isDescrizione(row)) {
            switch (cell.prop) {
                case 'ne_titolo':
                    return 'Input'
                case 'ne_descrizione_servizio':
                    return ModalInput
                default:
                    return 'Empty'
            }
        }
        if (this.hasNuvole(row)) {
            switch (cell.prop) {
                case 'ne_titolo':
                case 'ac_costo_totale':
                case 'ac_costo_totale_e':
                case 've_budget':
                case 've_budget_e':
                case 've_budget_lordo_iva':
                case 'ac_costo_unitario':
                case 'ac_unita':
                case 'ac_qta':
                case 've_vendita_unitario':
                case 've_unita':
                case 've_ovn':
                case 've_note':
                case 'ac_note_interne':
                case 'ac_ovn_gg':
                case 've_ovn_gg':
                case 've_qta':
                case 've_storico':
                    return 'Input'
                case 'ne_descrizione_servizio':
                case 've_aliquota':
                case 'ac_aliquota':
                case 've_valuta':
                case 'ac_valuta':
                    return ModalInput
                default:
                    return 'Empty'
            }
        }
        switch (cell.prop) {
            case 'ne_descrizione_servizio':
            case 'ne_voce_spesa':
            case 'ac_valuta':
            case 'ac_aliquota':
            case 've_valuta':
            case 've_fee':
            case 've_aliquota':
            case 'ne_fornitore':
            case 'ne_stato':
            case 'ne_tipologia':
                return ModalInput
            case 'ac_note_interne':
                return 'Input'
            // case 'ac_costo_unitario_netto':
            // case 'ac_costo_totale_e':
            // case 've_budget':
            // case 'budget_lordo_iva':
            // case 'mol':
            // case 'utile':
            //     return 'Text'
            default:
                return 'Input'
        }
    }

    rowCellIterator(righe: any[], colonne: any[]) {
        const res = []
        for (let i in righe) {
            for (let j in colonne) {
                res.push(`${i}_${colonne[j].prop}`)
            }
        }
        return res
    }

    azioni_visible = false
    waiting = false
    tabindex = -1

    get ActiveTab() {
        return this.dati.tabs[this.dati.active_tab]
    }

    aggiungiSezione(index: number) {
        const sez = {titolo: '', expanded: true, records: [], ordered_records: []}
        this.ActiveTab.sezioni.splice(index + 1, 0, sez)
        this.addRowSezione(sez)
    }

    duplicaSezione(index: number) {
        const sez = JSON.parse(JSON.stringify(this.ActiveTab.sezioni[index]))
        sez.ordered_records = []
        sez.records.forEach((e: any) => {
            e.id = uuidv4()
            e.nuvole?.forEach((n: any) => {
                n.id = uuidv4()
            })
            e.alternative?.forEach((a: any) => {
                a.id = uuidv4()
            })
        })
        this.ActiveTab.sezioni.splice(index, 0, sez);
        this.updateSectionData()
    }

    addRowSezione(s: any) {
        const newrow: any = {id: uuidv4(), type: TipoRigaPreventivo.OFFERTA}
        newrow['ve_fee'] = this.defaultFee
        newrow['ac_valuta'] = this.defaultAc
        newrow['ve_valuta'] = this.defaultVe
        newrow['ac_mark_up'] = this.defaultMarkUp
        s.records.push(newrow)
        this.updateSectionData()
    }

    // sul salva dei dati del sottoprogetto non dell'offerta
    onChangeSottoProgetto(data: any) {
        this.azioni_visible = false
        this.sottoprogetto_model = data
    }

    onCambiaStoricoVendite() {
        this.ActiveTab.sezioni.forEach(s => {
            s.records.forEach((r: any) => {
                if (r["ve_vendita_unitario"] !== undefined) {
                    r['ve_storico'] = r["ve_vendita_unitario"]
                }

                if (r.nuvole) {
                    r.nuvole.forEach((n: any) => {
                        if (n["ve_vendita_unitario"] !== undefined) {
                            n['ve_storico'] = n["ve_vendita_unitario"]
                        }
                    })
                }
            })
        })
        this.azioni_visible = false
        this.waiting = false
    }

    onUpdateValute(valute: never[]) {
        // sull'aggiunta di una valuta aggiorno i valori
        this.customValutaManager.setOptions(valute)
        this.setValute(valute).then(() => {
            this.dati.valute = valute
        })
    }

    onUpdateFees(fees: never[]) {
        this.setFees(fees).then(() => {
            this.dati.fee = fees
        })
    }

    syncUserPreference($event: any[]) {
        const _cols = $event.map((el: any) => {
            return {prop: el.prop, visible: el.visible, width: el.width}
        })
        //@ts-ignore
        this.$store.dispatch('buFieldModule/updateTableHeader', _cols).then((r) => {

            if (this.user_preference_timeout > 0) {
                clearTimeout(this.user_preference_timeout);
                this.user_preference_timeout = 0
            }
            //@ts-ignore
            this.user_preference_timeout = setTimeout(() => {
                this.saveUserPreferencesOnServer(_cols)
            }, 500)

        })
    }

    onUpdateRows(section: any, rows: any[]) {
        //elimino le nuvole e le alternative e lascio solo le righe principali
        section.records = rows.filter((r: any) => {
            return !(r._nuvola || r._alternativa)
        })
        this.updateSectionData()
    }

    saveUserPreferencesOnServer(cols: any[]) {
        return meManager.syncSottoprogettoPreference(this.id, {
            data: JSON.stringify(cols),
            stato: this.sottoprogetto_model
        })
    }

    promuoviSottoriga(section: any, sottoriga: any) {
        if (sottoriga._nuvola) {
            let index_record = -1
            let index_nuvola = -1
            section.records.forEach((r: any, ir: number) => {
                if (r.nuvole && index_nuvola == -1) {
                    index_record = ir
                    index_nuvola = r.nuvole.indexOf(sottoriga)
                }
            })
            if (index_record > -1 && index_nuvola > -1) {
                const rec = section.records.splice(index_record, 1)[0]
                const nuv = rec.nuvole.splice(index_nuvola, 1)[0]
                rec._nuvola = true
                rec.type = TipoRigaPreventivo.OFFERTA
                nuv.nuvole = rec.nuvole
                nuv.alternative = rec.alternative
                nuv.type = TipoRigaPreventivo.OFFERTA
                delete rec.alternative
                delete rec.nuvole
                delete nuv._nuvola
                section.records.splice(index_record, 0, nuv)
                nuv.nuvole.splice(index_nuvola, 0, rec)
            }
        } else if (sottoriga._alternativa) {
            let index_record = -1
            let index_alternativa = -1
            section.records.forEach((r: any, ir: number) => {
                if (r.alternative && index_alternativa == -1) {
                    index_record = ir
                    index_alternativa = r.alternative.indexOf(sottoriga)
                }
            })
            if (index_record > -1 && index_alternativa > -1) {
                const rec = section.records.splice(index_record, 1)[0]
                const alt = rec.alternative.splice(index_alternativa, 1)[0]
                rec._alternativa = true
                rec.type = TipoRigaPreventivo.OFFERTA
                alt.nuvole = rec.nuvole
                alt.alternative = rec.alternative
                alt.type = TipoRigaPreventivo.OFFERTA
                delete rec.alternative
                delete rec.nuvole
                delete alt._alternativa
                section.records.splice(index_record, 0, alt)
                alt.alternative.splice(index_alternativa, 0, rec)
            }
        }
        this.updateSectionData()
    }
}


</script>


<style lang="scss"></style>
